import React from 'react';
import { withNativeProps } from '@/utils/with-native-props';
import { CnIcon } from '@/components/cn-icon';
import classNames from 'classnames';
const classPrefix = `cn-ui-m-nav-bar`;
const CnNavBar = (props) => {
    const { back, backArrow = true, enableSafeArea } = props;
    const content = withNativeProps(props, React.createElement("div", { className: classNames(classPrefix) },
        React.createElement("div", { className: `${classPrefix}-left`, role: "button" },
            back !== null && (React.createElement("div", { className: `${classPrefix}-back`, onClick: props.onBack },
                backArrow && (React.createElement("span", { className: `${classPrefix}-back-arrow` }, backArrow === true ? (React.createElement(CnIcon, { type: "arrow-left", size: "xl" })) : (backArrow))),
                React.createElement("span", { "aria-hidden": "true" }, back))),
            props.left ? (React.createElement("div", { className: `${classPrefix}-left-content` }, props.left)) : null),
        React.createElement("div", { className: `${classPrefix}-title-container` },
            props.title ? (React.createElement("div", { className: `${classPrefix}-title` }, props.title)) : null,
            props.subTitle ? (React.createElement("div", { className: `${classPrefix}-subtitle` }, props.subTitle)) : null),
        React.createElement("div", { className: `${classPrefix}-right` }, props.right)));
    return (React.createElement("div", { className: classNames(`${classPrefix}-wrapper`) },
        enableSafeArea ? (React.createElement("div", { className: classNames(`${classPrefix}-safe-area`) })) : null,
        content));
};
CnNavBar.displayName = 'CnNavBar';
CnNavBar.defaultProps = {
    backArrow: true,
};
export { CnNavBar };
